import apiV2 from "api-v2";
import { ApiResponse } from "types/common.types";
import { RfxProjectLite } from "../../types/rfx.types";

export const getProjectSupplier = async () => {
	try {
		const { data: lists } = await apiV2.get<ApiResponse<RfxProjectLite>>(
			`project/retrieve-project-lite`
		);
		if (lists.status) {
			return lists.data;
		} else {
			return null;
		}
	} catch (err) {
		throw new Error(err?.response?.data?.message);
	}
};
